import { defineStyleConfig } from '@chakra-ui/react';

import { chakraDefaultFocusStyles } from 'theme/themeConstants';

const IconButton = defineStyleConfig({
  baseStyle: {
    minWidth: '0',
    height: 'auto',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'transparent',
    borderRadius: 'circle',
    padding: '10px',
    color: 'brand.default',
    backgroundColor: 'background.white',
    transition:
      'border-color 0.2s ease-in, box-shadow 0.2s ease-in, color 0.2s ease-in, background-color 0.2s ease-in',

    _active: {
      backgroundColor: 'brand.default_L83',
    },

    _disabled: {
      opacity: 1,
      color: 'text.tertiary',

      _hover: {
        borderColor: 'inherit',
        boxShadow: 'none',
        backgroundColor: 'inherit',
      },
    },

    _focus: {
      boxShadow: chakraDefaultFocusStyles.boxShadow,
    },

    _hover: {
      borderColor: 'brand.default_L83',
      boxShadow: `0 2px 10px 0 var(--chakra-colors-brand.default_HalfS_L80)`,
      backgroundColor: 'brand.default_L93',
    },
  },
});

export default IconButton;
